import React, {useState} from "react";
import Modal from "react-responsive-modal";

import ModalNeedHelp from "./ModalNeedHelp";

const useModalNeedHelp = ( onSaveCompleted ) =>
{
    const [dialog, setDialog]  = useState ( { openState: false, mode: 'none' })  ;

    const onClickActivate = ( {mode} ) =>
    {
            setDialog({openState: true, mode: mode });
    }

    const onCloseModal = () =>
    {
        setDialog ({openState: false, mode: 'none' });
    };

    const onSaveComplete = ( operation ) =>
    {
        // Close the dialog
        setDialog ({openState: false, mode: 'none' });

        // Tell the parent we're done
        onSaveCompleted( operation ) ;
    };

    const render = () =>
    {
        return (
            <Modal center focusTrapped={true} open={dialog.openState} closeOnOverlayClick={false} onClose={onCloseModal}>
                { dialog.mode !== 'none' && < ModalNeedHelp  onSaveCompleted={onSaveComplete} onClose={onCloseModal}
                                               mode={dialog.mode} /> }
            </Modal>
        )
    }

    return [ render, onClickActivate ] ;
}

export default useModalNeedHelp;